import React, { useState } from "react";
import DealerContactInfo from "./DealerContactInfo";
import { withTranslation } from "react-i18next";
import styles from "./DealerShipDetails.module.scss";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";

function DealershipDetails(props) {
  const [renderAgain, setRenderAgain] = useState(false);

  const enableLiveUpdateEmployees = () => {
    setRenderAgain(true);
  };

  const disableLiveUpdateEmployees = () => {
    setRenderAgain(false);
  };

  return (
    <>
      <div className="pageInfoWrapper pagePaddingLeft pagePaddingTop pagePaddingRight">
        <InfoIconWithMessage
          message={props.t("DealerShipDetails.pageInfo")}
        />
      </div>
      <div className={`${styles.topPadding} pageWrapper`}>
        {Object.keys(props.filteredDealers).length !== 0
          ? Object.keys(props.filteredDealers).map((commonId) => {
            return (
              <DealerContactInfo
                {...props}
                renderAgain={renderAgain}
                disableLiveUpdateEmployees={disableLiveUpdateEmployees}
                dealers={props.filteredDealers[commonId]}
                enableLiveUpdateEmployees={enableLiveUpdateEmployees}
                key={commonId}
              />
            );
          })
          : null}
      </div>
    </>
  );
}

export default withTranslation("emp")(DealershipDetails);
